import axios from "axios";
import jwtDecode from 'jwt-decode';
import { BaseList, BaseResponse, ISettingData } from "../dto/BaseResponse";
import { LoginResponse, UserInfo } from "../redux/AuthRedux";
//const serverUrl = "https://manodr.ir/";
setHeaderAxios();
const serverUrl = process.env.REACT_APP_API_URL;
export function getToken() {
    var data = localStorage.getItem('Authorization');
    if (data) {
        var jsonData = JSON.parse(data) as LoginResponse;
        if (jsonData) {
            return jsonData.access_token;
        }
    }
    return null;
}
export function setHeaderAxios() {
    var token = getToken();
    if (isAuthTokenValid(token))
        axios.defaults.headers.common['Authorization'] = "Bearer " + token;
}
export const saveToken = (token: any) => {
    localStorage.setItem('Authorization', JSON.stringify(token));
    setHeaderAxios();
};
export const clearToken = () => {
    localStorage.removeItem('Authorization');
};
export function isAuthTokenValid(access_token: string | null) {

    if (!access_token)
        return false;
    const decoded = jwtDecode(access_token) as any;

    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
        console.warn('access token expired');
        return false;
    }

    return true;
};

export const ApiServices = {
    dashbaord: {
        get: () => axios.get<any>(serverUrl + `/v1/dashboard`)
            .then(res => res.data),
    },
    users: {
        list: (page: number, pageSize: number) => axios.get<BaseList<any>>(serverUrl + `/v1/users?page=${page}&pageSize=${pageSize}`)
            .then(res => res.data),
        changepassword: (formdata: any) => axios.post<BaseResponse<any>>(serverUrl + `/v1/users/changepassword`, formdata)
            .then(res => res.data),
    },
    foodCategorys: {
        list: (page: number, pageSize: number,searchName?:string) => axios.get<BaseList<any>>(serverUrl + `/v1/foodCategorys?page=${page}&pageSize=${pageSize}${searchName ? '&searchName=' + searchName : ''}`)
            .then(res => res.data),
        listName: () => axios.get<BaseList<any>>(serverUrl + `/v1/foodCategorys/listName`)
            .then(res => res.data),
        create: (formdata: any) => axios.post<BaseResponse<any>>(serverUrl + `/v1/foodCategorys`, formdata)
            .then(res => res.data),
        get: (id: number) => axios.get<BaseResponse<any>>(serverUrl + `/v1/foodCategorys/${id}`)
            .then(res => res.data),
        edit: (id: number, formdata: any) => axios.put<BaseResponse<any>>(serverUrl + `/v1/foodCategorys/${id}`, formdata)
            .then(res => res.data),
        delete: (id: number) => axios.delete<BaseResponse<any>>(serverUrl + `/v1/foodCategorys/${id}`)
            .then(res => res.data),
    },
    tableTheme: {
        list: (page: number, pageSize: number) => axios.get<BaseList<any>>(serverUrl + `/v1/tableTheme?page=${page}&pageSize=${pageSize}`)
            .then(res => res.data),
        create: (formdata: any) => axios.post<BaseResponse<any>>(serverUrl + `/v1/tableTheme`, formdata)
            .then(res => res.data).catch(err => { return { success: false, message: err, entity: null } }),
        get: (id: number) => axios.get<BaseResponse<any>>(serverUrl + `/v1/tableTheme/${id}`)
            .then(res => res.data),
        edit: (id: number, formdata: any) => axios.put<BaseResponse<any>>(serverUrl + `/v1/tableTheme/${id}`, formdata)
            .then(res => res.data).catch(err => { return { success: false, message: err, entity: null } }),
        listItems: () => axios.get<BaseList<any>>(serverUrl + `/v2/shop/tableTheme`)
            .then(res => res.data),
        delete: (id: number) => axios.delete<BaseResponse<any>>(serverUrl + `/v1/tableTheme/${id}`)
            .then(res => res.data),
    },
    foods: {
        list: (page: number, pageSize: number, searchName?: string, categoryName?: string) =>
            axios.get<BaseList<any>>(serverUrl + `/v1/foods?page=${page}&pageSize=${pageSize}${searchName ? '&searchName=' + searchName : ''}${categoryName ? '&categoryName=' + categoryName : ''}`)
                .then(res => res.data),
        create: (formdata: any) => axios.post<BaseResponse<any>>(serverUrl + `/v1/foods`, formdata)
            .then(res => res.data).catch(err => { return { success: false, message: err, entity: null } }),
        get: (id: number) => axios.get<BaseResponse<any>>(serverUrl + `/v1/foods/${id}`)
            .then(res => res.data),
        edit: (id: number, formdata: any) => axios.put<BaseResponse<any>>(serverUrl + `/v1/foods/${id}`, formdata)
            .then(res => res.data),
        delete: (id: number) => axios.delete<BaseResponse<any>>(serverUrl + `/v1/foods/${id}`)
            .then(res => res.data),
    },
    auth: {
        login: (formData: any) => axios.post<BaseResponse<LoginResponse>>(serverUrl + "/v1/auth/login", formData).then(res => res.data)
            .catch(err => { return { success: false, message: err, entity: null } }),
        checkToken: () => axios.get<BaseResponse<UserInfo>>(serverUrl + `/v1/users/current`)
            .then(res => res.data),
    },
    translations: {
        get: (lan: string) => axios.get<BaseResponse<any>>(serverUrl + `/v1/translations/${lan}`)
            .then(res => res.data),
        list: () => axios.get<BaseList<any>>(serverUrl + `/v1/translations`)
            .then(res => res.data),
    },
    shop: {
        listCategory: () => axios.get<BaseList<any>>(serverUrl + `/v2/shop/foodCategorysList`)
            .then(res => res.data),
        listFoods: (categoryId: number) => axios.get<BaseList<any>>(serverUrl + `/v2/shop/foodList/` + categoryId)
            .then(res => res.data),
        getSetting: () => axios.get<BaseResponse<ISettingData>>(serverUrl + `/v2/shop/setting`)
            .then(res => res.data),
        orderRegister: (formData: any, token: string) => axios.post<BaseResponse<any>>(serverUrl + "/v2/shop/order", formData, { headers: { Authorization: `Bearer ${token}` } }).then(res => res.data)
            .catch(err => { return { success: false, message: err, entity: null } }),
    },
    customer: {
        sendSmsVerification: (formData: any) => axios.post<BaseResponse<any>>(serverUrl + "/v2/customers/sendSmsVerification", formData).then(res => res.data)
            .catch(err => { return { success: false, message: err, entity: null } }),
        verifySms: (formData: any) => axios.post<BaseResponse<any>>(serverUrl + "/v2/customers/VerifySms", formData).then(res => res.data)
            .catch(err => { return { success: false, message: err, entity: null } }),
        list: (page: number, pageSize: number) => axios.get<BaseList<any>>(serverUrl + `/v1/customers?page=${page}&pageSize=${pageSize}`)
            .then(res => res.data),
        delete: (id: number) => axios.delete<BaseResponse<any>>(serverUrl + `/v1/customers/${id}`)
            .then(res => res.data),
        increaseCredit: (formdata: any) => axios.post<BaseResponse<any>>(serverUrl + `/v1/customers/increaseCredit`, formdata)
            .then(res => res.data).catch(err => { return { success: false, message: err, entity: null } }),
    },
    orders: {
        changeStatus: (formdata: any) => axios.put<any>(serverUrl + `/v1/orders/changeStatus`, formdata)
            .then(res => res.data),
        delete: (id: number) => axios.delete<BaseResponse<any>>(serverUrl + `/v1/orders/${id}`)
            .then(res => res.data),
        list: (page: number, pageSize: number) => axios.get<BaseList<any>>(serverUrl + `/v1/orders?page=${page}&pageSize=${pageSize}`)
            .then(res => res.data),
    },
    paymentTransactions: {

        list: (page: number, pageSize: number) => axios.get<BaseList<any>>(serverUrl + `/v1/paymentTransactions?page=${page}&pageSize=${pageSize}`)
            .then(res => res.data),
        delete: (id: number) => axios.delete<BaseResponse<any>>(serverUrl + `/v1/paymentTransactions/${id}`)
            .then(res => res.data),
    }


}